import { makeStyles } from '@material-ui/core';
import { StateConfig } from 'src/common/interfaces/dtos/ITouchpointTheme';
import { themeColor } from 'src/mui-theme';

const paddingBottom = '3.9vh';

export const styles = makeStyles(theme => ({
  barNotification: {
    backgroundColor: theme.palette.primary.main,
  },
  bar: {
    width: '5vw',
    height: '1vh',
    margin: 'auto',
    // The others use padding, this guy needs margin
    marginBottom: paddingBottom,
  },
  title: {
    color: ({ headingTextColor }: StateConfig) => (headingTextColor ? headingTextColor : ''),
    fontSize: '3rem',
    fontWeight: 700,
    lineHeight: '3.33rem',
    fontFamily: 'Raleway',
    paddingBottom,
  },
  amount: {
    fontWeight: 500,
    fontSize: '2rem',
    letterSpacing: 0.2,
    color: ({ headingTextColor }: StateConfig) => (headingTextColor ? headingTextColor : ''),
    paddingBottom,
  },
  subtitle: {
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontSize: '1.875rem',
    lineHeight: '2.2rem',
    color: ({ bodyTextColor }: StateConfig) =>
      bodyTextColor ? bodyTextColor : themeColor.lockTextColor,
    textAlign: 'center',
  },
  subTitleContainer: {
    width: '39vw',
    '@media  (max-height: 577px)': {
      width: '70vw',
    },
  },
  line: {
    paddingBottom,
  },
  customerCartLogo: {
    width: '100%',
    maxWidth: '360px',
  },
  thankYouContainer: {
    flexGrow: 1,
    zIndex: 1,
  },
  logo: {
    bottom: '3%',
    height: '8vh',
  },
  trainingModeBackground: {
    backgroundColor: `${themeColor.trainingBackground}!important`,
  },
  themeBackground: {
    backgroundImage: ({ backgroundImageURL }: StateConfig) =>
      backgroundImageURL ? `url(${backgroundImageURL})` : '',
    backgroundColor: ({ backgroundColor }: StateConfig) => (backgroundColor ? backgroundColor : ''),
  },
  trainingWaterMark: {
    right: '0',
    top: '45%',
    zIndex: 0,
    fontSize: '2.8rem',

    '@media (min-width: 1024px)': {
      fontSize: '2.8rem',
    },
    '@media (min-width: 1280px)': {
      fontSize: '3.2rem',
    },
    '@media (min-width: 1366px)': {
      fontSize: '3.5rem',
    },
    '@media (min-width: 1600px)': {
      fontSize: '4.6rem',
    },
    '@media (min-width: 1920px)': {
      fontSize: '5.6rem',
    },
  },
}));
